import { QuestionTypes } from '@shory-health-individual/customer-api';

export interface MafQuestion {
	id: number;
	questionText: string;
	dataTypeId: QuestionTypes;
	parentQuestionId: number | null;
	questionTextKey: string;
	questionResourceKey: string;
	savedAnswerId: number | null;
	savedAnswer: string | null;
	answers: MafAnswer[];
}

export interface MafAnswer {
	id: number;
	questionId: number;
	isCustomAnswer: boolean;
	answerText: string;
	answerParentId: number;
	customAnswerText: string | null;
	answerResourceKey: string;
}

export type GetMafMemberQuestionsHandler = ReturnType<typeof useMemberQuestions>['getMemberQuestions'];

export type GetMafSavedMedicalAnswerHandler = ReturnType<typeof useMemberQuestions>['getSavedMedicalAnswer'];

export type GetMafMemberQuestionsAnswersHandler = ReturnType<typeof useMemberQuestions>['getMemberQuestionsAnswers'];

export const useMemberQuestions = (questions: MafQuestion[]) => {
	const getMemberQuestions = (parentQuestionId: null | number) => {
		if (!parentQuestionId) {
			return questions?.filter((question) => !question.parentQuestionId);
		}

		return questions?.filter((question) => question.parentQuestionId === parentQuestionId);
	};

	const getSavedMedicalAnswer = (questionId: number) => {
		const q = questions?.find((question) => question.id === questionId);

		return q?.savedAnswerId || q?.savedAnswer;
	};

	const getMemberQuestionsAnswers = (questionId: number) =>
		questions?.find((question) => question.id == questionId)?.answers?.sort((a, b) => b.id - a.id);

	return {
		getMemberQuestions,
		getMemberQuestionsAnswers,
		getSavedMedicalAnswer,
	};
};
